import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

import {Destroyable} from '../../../destroyable.component';
import {DataTransformer} from '../../form-generator/data-transformer/data-transformer';
import {GroupZoneDescriptor, ZoneDescriptor, ZoneValues} from '../../form-generator/form-generator.interfaces';
import {FormGeneratorService} from '../../form-generator/form-generator.service';
import {GeneratedSimpleFormComponent} from '../../form-generator/generated-simple-form/generated-simple-form.component';

import {VariableZoneService} from './variable-zone.service';
import { ProfileMode } from '../../../app.constants';

/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */


@Component({
  selector: 'gp-variable-zones',
  template: `
  <gp-generated-simple-form
    [groupZoneDescriptor]="repVariableGroupZoneDescriptor"
    [values]="repVariableZoneValues"
    [readOnly]="readOnly"
    [profileMode]="profileMode"
    (formStabilised)="generatedSimpleFormLoaded()">
  </gp-generated-simple-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VariableZonesComponent extends Destroyable implements OnInit, OnChanges {

  @Input()
  public contractId: number;

  @Input()
  public cliRegId: number;

  @Input()
  public isEss: boolean;

  @Input()
  public data: any;

  @Input()
  public name: string;

  @Input()
  public readOnly: boolean;

  @Output()
  public formLoaded: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(GeneratedSimpleFormComponent, {static: true})
  public generatedSimpleForm: GeneratedSimpleFormComponent;

  public repVariableGroupZoneDescriptor: GroupZoneDescriptor;

  public repVariableZoneValues: ZoneValues;

  constructor(private variableZoneService: VariableZoneService,
              private formGeneratorService: FormGeneratorService,
              private ref: ChangeDetectorRef) {
    super();
  }

  public get profileMode(): ProfileMode {
    return this.isEss ? ProfileMode.ESS : ProfileMode.CLASSIC;
  }

  public ngOnInit() {
  }

  public ngOnChanges() {
    this.repVariableGroupZoneDescriptor = null;
    this.repVariableZoneValues = null;
    if (!this.cliRegId || !this.name) {
      return;
    }
    this.variableZoneService.getRepVariableZones(this.cliRegId, this.name, this.isEss)
      .subscribe((zones: Array<ZoneDescriptor>) => {
        if (zones) {
          const groupZoneDescriptor = this.formGeneratorService.createEmptyGroupZoneDescriptor(name, zones);
          groupZoneDescriptor.zones.forEach((zone: ZoneDescriptor) => {
            if (zone.type === 'FILE') {
              if (!zone.metadatas) {
                zone.metadatas = {};
              }
              zone.metadatas.contractId = this.contractId;
            }
          });
          this.repVariableGroupZoneDescriptor = groupZoneDescriptor;
          const data = this.data.attributes.values ? [this.data.attributes] : [];
          this.repVariableZoneValues = DataTransformer.createZoneValues(groupZoneDescriptor, this.formGeneratorService, data)[0];
        }
        this.refreshView();
      });
  }

  public refreshView(): void {
    if (!this.isDestroyed) {
      this.ref.detectChanges();
    }
  }

  public generatedSimpleFormLoaded() {
    this.formLoaded.emit();
  }

  public isFormValid() {
    return this.generatedSimpleForm.form.valid;
  }

  public getModifiedCardsData() {
    return this.generatedSimpleForm.getModifiedCardsData();
  }
}
